import React, {Component} from 'react';
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import TxtLbl from "../../../../../components/Input/Input/TxtLbl";
import DrpDwn from "../../../../../components/Dropdown/Dropdown/DrpDwn";
import * as actionCreator from "../../../../../store/Action";
import {connect} from "react-redux";
import * as DropDownConst from '../../../../../store/Reducer/DropDownConst'
import * as common from "../../../../../const/Common/CommonFunc";
import {Button, Checkbox, Form, Input, Label} from 'semantic-ui-react'
import * as Validator from "../../../../../util/Validator";
import * as EmailValidator from "email-validator/index";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../assets/img/sweet/question.svg";
import Cookies from "js-cookie";
import axiosTags from "../../../../../axios/axios_tag";
import $ from "jquery";
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import apiConfig from "../../../../../axios/axios_api_services";

class App extends Component {

  state = {
    formData: {
      title: {value: ''},
      firstName: {value: ''},
      lastName: {value: ''},
      email: {value: ''},
      mobileNo: {value: ''},
      identificationType: {value: ''},
      identificationValue: {value: ''},

      addressId: {value: ''},
      address_line_1: {value: ''},
      address_line_2: {value: ''},
      country: {value: 'Sri Lanka'},
      province_state: {value: ''},
      district: {value: ''},
      city_town: {value: ''},
      zip: {value: ''},

      emgFullName: {value: ''},
      emgMobileNo: {value: ''},

      empId: {value: ''},

      department: {value: ''},
      budgetRef: {value: ''},
      otherRef: {value: ''},

      gender: {value: ''},
      designation: {value: ''},
      extension: {value: ''},

    },
    rating:  {value: ""},
    isVIP:  {value: ""},
    departmentData_list: [],
    completeCopUser: false,
    completeEmg: false,
    completeCompany: false,
    formValidate: false,
  };

  settleData = () => {
    let data = this.props.data;

    this.setState({
      formData: {
        title: {value: data.title === null ? "" : data.title},
        firstName: {value: data.firstName === null ? "" : data.firstName},
        lastName: {value: data.lastName === null ? "" : data.lastName},
        email: {value: data.email === null ? "" : data.email},
        mobileNo: {value: data.mobile === null ? "" : data.mobile.startsWith("94") ? data.mobile.substr(2) : data.mobile},
        identificationType: {value: data.identificationType === null ? "" : data.identificationType},
        identificationValue: {value: data.identificationValue === null ? "" : data.identificationValue},

        addressId: {value: data.addressEntities.length !== 0 ? data.addressEntities[0].addressId : 0},
        address_line_1: {value: data.addressEntities.length !== 0 ? data.addressEntities[0].line1 : ""},
        address_line_2: {value: data.addressEntities.length !== 0 ? data.addressEntities[0].line2 : ""},
        country: {value: 'Sri Lanka'},
        province_state: {value: data.addressEntities.length !== 0 ? data.addressEntities[0].province : ""},
        district: {value: data.addressEntities.length !== 0 ? data.addressEntities[0].district : ""},
        city_town: {value: data.addressEntities.length !== 0 ? data.addressEntities[0].city : ""},
        zip: {value: data.addressEntities.length !== 0 ? data.addressEntities[0].postalCode : ""},


        emergencyId: {
          value: data.userEmergencyContactEntity !== null ? data.userEmergencyContactEntity.emergencyId : 0
        },

        emgFullName: {value: data.userEmergencyContactEntity !== null ? data.userEmergencyContactEntity.fullName : ""},
        emgMobileNo: {value: data.userEmergencyContactEntity !== null ? data.userEmergencyContactEntity.emergency_mobile.startsWith("94") ? data.userEmergencyContactEntity.emergency_mobile.substr(2) : data.userEmergencyContactEntity.emergency_mobile : ""},

        empId: {value: data.empId === null ? "" : data.empId},

        department: {value: data.departmentEntity !== null ? data.departmentEntity.departmentId : 0},
        budgetRef: {value: data.budgetReferance === null ? "" : data.budgetReferance},
        otherRef: {value: data.otherReferance === null ? "" : data.otherReferance},

        gender: {value: data.gender === null || data.gender === "NONE" ? "" : data.gender},
        designation: {value: data.designation === null ? "" : data.designation},
        extension: {value: data.extention === null ? "" : data.extention},
      },
      isVIP: data.vip ,
      rating: data.points
    })
  };

  rateStarsVIP = (value) => {
    this.setState({rating: value.target.value})
  };

  removeBorders = () => {
    this.setState({
      completeCopUser: null,
      completeEmg: null,
      completeCompany: null,
    })
  };

  isValidate = () => {

    this.removeBorders();
    let isCorporate = this.validateCorporate();
    if (isCorporate) {
          swal({
            title: "Are you sure do you want to update this user?",
            icon: are_you_sure_icon,
            closeOnClickOutside: false,
            buttons: {
              cancel: 'Cancel',
              dangerMode: {
                text: "Yes",
                value: "action",
                className: "okay-btn"
              }
            },
          }).then((value) => {

            switch (value) {
              case "action":
                this.submitForm();
                break;
              default:
                break;
            }
          });
    }
  };

  validateCorporate = () => {
    if (this.state.formData.title.value === ""
      || this.state.formData.firstName.value.trim() === ""
      || this.state.formData.lastName.value.trim() === ""
      || this.state.formData.gender.value === ""
      || this.state.formData.mobileNo.value.trim() === ""
      || this.state.formData.identificationType.value.trim() === ""
      || this.state.formData.identificationValue.value.trim() === ""
      || this.state.formData.email.value.trim() === ""
    // || this.state.formData.address_line_1.value.trim() === ""
    // || this.state.formData.province_state.value.trim() === ""
    // || this.state.formData.district.value.trim() === ""
    // || this.state.formData.city_town.value.trim() === ""
    ) {

      common.notifyMessage("Please enter corporate details (required fields)");
      this.setState({
        completeCopUser: true
      });
      return false
    } else {

      let condition = false;

      if (Validator.mobileNumValidator(this.state.formData.mobileNo.value, null, 1)) {
        condition = false
      } else {
        common.notifyMessage("Please enter valid mobile number", 0, 2);
        condition = true
      }
      // email validator
      if (!condition) {
        if(this.state.formData.email.value.trim() !== "") {
          let validateEmail = EmailValidator.validate(this.state.formData.email.value.trim());
          if (validateEmail) {
            condition = false
          } else {
            common.notifyMessage("Please enter valid email address", 0, 2);
            condition = true
          }
        } else {
          common.notifyMessage("Email address cannot be empty", 0, 2);
          condition = true
        }
      }

      if (condition) {
        this.setState({
          completeCopUser: true
        });
        return false
      } else {
        this.setState({
          completeCopUser: false
        });
        return true;
      }
    }
  };

  validateEmg = () => {
    // if (this.state.formData.emgFullName.value.trim() === ""
    //   || this.state.formData.emgMobileNo.value.trim() === "") {
    //
    //   common.notifyMessage("Please enter Emergency contact details");
    //   this.setState({
    //     completeEmg: true
    //   });
    //   return false
    // } else {
    //
    //   let condition = false;
    //
    //   if (this.state.formData.emgMobileNo.value.trim() !== "") {
    //     if (this.state.formData.emgMobileNo.value.length >= 9) {
    //       condition = false
    //     } else {
    //       common.notifyMessage("Please enter valid mobile number", 0, 2);
    //       condition = true
    //     }
    //   }
    //
    //   if (condition) {
    //     this.setState({
    //       completeEmg: true
    //     });
    //     return false
    //   } else {
    //     this.setState({
    //       completeEmg: false
    //     });
    //     return true;
    //   }
    // }
    let condition = false;

    if (this.state.formData.emgMobileNo.value.trim() !== "") {
      if (Validator.mobileNumValidator(this.state.formData.emgMobileNo.value, null, 1)) {
        condition = false
      } else {
        common.notifyMessage("Please enter valid mobile number", 0, 2);
        condition = true
      }
    }

    if (condition) {
      this.setState({
        completeEmg: true
      });
      return false
    } else {
      this.setState({
        completeEmg: false
      });
      return true;
    }
  };

  validateCompany = () => {
    if (this.state.formData.empId.value.trim() === ""
      || this.state.formData.designation.value.trim() === ""
      || this.state.formData.department.value === "") {

      common.notifyMessage("Please enter Company related contact details");
      this.setState({
        completeCompany: true
      });
      return false
    } else {
      this.setState({
        completeCompany: false
      });
      return true;
    }

  };

  handleChange = (name, length) => event => {
    let value = '';

    if (name === "mobileNo" || name === "emgMobileNo") {
      let reg = /^\d+$/;
      if (reg.test(event.target.value) || event.target.value === "") {
        value = event.target.value;
      }
    } else {
      value = event.target.value;
    }

    const valid = Validator.textFieldValidator(value, length);

    const formData = {
      ...this.state.formData
    };
    formData[name].value = value;
    formData[name].valid = valid;

    this.setState({
      formData: formData
    });

    let formValid = true;
    for (let inputIdentifier in formData) {
      formValid = formData[inputIdentifier].valid && formValid
    }

    this.setState({
      formValidate: formValid
    });
  };
  dropDownChange = name => (event, {value}) => {
    const formData = {
      ...this.state.formData
    };
    formData[name].value = value;
    formData[name].valid = true;

    this.setState({
      formData: formData
    });

    let formValid = true;
    for (let inputIdentifier in formData) {
      formValid = formData[inputIdentifier].valid && formValid
    }

    this.setState({
      formValidate: formValid
    });

  };

  getAllDepartment = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.CORPORATE_DEPARTMENT(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            departmentData_list: response.data.departmentList
          })
        } else {
          this.setState({
            departmentData_list: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllDepartment()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
        this.settleData();
      });
  };
  isVIPSelector = async () => {
    await this.setState({isVIP: !this.state.isVIP})
  };


  submitForm = () => {
    let userEmergencyContactObj = {
      emergencyId: this.state.formData.emergencyId.value,
      emergency_mobile: this.state.formData.emgMobileNo.value,
      fullName: this.state.formData.emgFullName.value
    };
    if (this.state.formData.emgMobileNo.value.trim() === "" && this.state.formData.emgFullName.value.trim() === "") {
      userEmergencyContactObj = null;
    }
    const obj = {
      userId: this.props.data.userId,
      title: this.state.formData.title.value,
      firstName: this.state.formData.firstName.value,
      lastName: this.state.formData.lastName.value,
      gender: this.state.formData.gender.value,
      mobile: this.state.formData.mobileNo.value,
      identificationType: this.state.formData.identificationType.value,
      identificationValue: this.state.formData.identificationValue.value,

      email: this.state.formData.email.value,
      corporateEmail: null,
      emailOTP: null,
      corporateEmailOTP: null,
      profilePic: null,

      addressEntities: [
        {
          addressId: this.state.formData.addressId.value,
          line1: this.state.formData.address_line_1.value,
          line2: this.state.formData.address_line_2.value,
          city: this.state.formData.city_town.value,
          district: this.state.formData.district.value,
          province: this.state.formData.province_state.value,
          postalCode: this.state.formData.zip.value,
          country: "Sri Lanka",
          status: 1
        }
      ],
      vip: this.state.isVIP,
      points:this.state.rating,
      userEmergencyContactEntity: userEmergencyContactObj,
    };

    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axiosTags.post(apiConfig.UPDATE_PUBLIC_USERS, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("User details successfully updated", 0);
          this.props.closeModal();
          this.props.reloadTable();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.submitForm()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });

  };

  async componentDidMount() {
    $('input').attr('autocomplete', 'off');
    this.getAllDepartment();
    console.log(this.props.data.vip)
    // if (this.props.data.vip) {
    //  await this.isVIPSelector();
    //   await this.setState({rating: this.props.data.rating})
    // }
  }

  render() {
    const rows = [];

    if (this.state.departmentData_list.length !== 0) {
      this.state.departmentData_list.map((row, index) => {
        rows.push(
          {
            key: index,
            text: row.name,
            value: row.departmentId,
          }
        )
      });
    }

    return (
      <div>
        <MDBModal isOpen={true} toggle={this.toggle} size="lg">
          <MDBModalHeader className={"title"} toggle={this.props.closeModal}>
            Update Public User Details
          </MDBModalHeader>
          <MDBModalBody>
            <Row>
              <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
                <Card className={this.state.completeCopUser ? "border-danger" : null}>
                  <CardHeader>
                    PUBLIC USER DETAILS
                  </CardHeader>
                  <Collapse isOpen={true} id="collapseExample">
                    <CardBody>

                      {/*corporate user details*/}
                      <Form>
                        <Form.Group widths='equal'>
                          <DrpDwn
                            required
                            tagText={"Title"}
                            placeholder={"Title"}
                            options={DropDownConst.userTitle}
                            value={this.state.formData.title.value}
                            onChange={this.dropDownChange('title')}
                          />
                          <DrpDwn
                            required
                            tagText={"Gender"}
                            placeholder={"Gender"}
                            options={DropDownConst.gender}
                            value={this.state.formData.gender.value}
                            onChange={this.dropDownChange('gender')}
                          />

                        </Form.Group>
                      </Form>
                      <Form>
                        <Form.Group widths='equal'>
                          <TxtLbl
                            required
                            tagText={"First Name"}
                            placeholder={"First Name"}
                            value={this.state.formData.firstName.value}
                            onChange={this.handleChange('firstName', 1)}
                          />

                          <TxtLbl
                            required
                            tagText={"Last Name"}
                            placeholder={"Last Name"}
                            value={this.state.formData.lastName.value}
                            onChange={this.handleChange('lastName', 1)}
                          />

                        </Form.Group>


                      </Form>

                      {/*corporate email/tel*/}
                      <Form>
                        <Form.Group widths='equal'>
                          <TxtLbl
                            required
                            tagText={"Email Address"}
                            placeholder={"Email Address"}
                            value={this.state.formData.email.value}
                            onChange={this.handleChange('email', 1)}
                          />
                        </Form.Group>

                        <Form.Group widths='equal'>
                          <TxtLbl
                            required
                            tagText={"Mobile Number"}
                            placeholder={"Mobile Number"}
                            value={this.state.formData.mobileNo.value}
                            onChange={this.handleChange('mobileNo', 1)}
                          />
                        </Form.Group>
                        <Form.Group widths='equal'>
                          <DrpDwn
                            required
                            tagText={"Identification Type"}
                            placeholder={"Identification Type"}
                            options={DropDownConst.Identifications()}
                            value={this.state.formData.identificationType.value}
                            onChange={this.dropDownChange('identificationType')}
                          />
                          <TxtLbl
                            required
                            tagText={"Identification Value"}
                            placeholder={"Identification Value"}
                            value={this.state.formData.identificationValue.value}
                            onChange={this.handleChange('identificationValue', 1)}
                          />

                        </Form.Group>
                      </Form>

                      {/*address*/}

                      <Form>
                        <Form.Group widths='equal'>
                          <TxtLbl
                            // required
                            tagText={"Address Line 1"}
                            placeholder={"Address Line 1"}
                            value={this.state.formData.address_line_1.value}
                            onChange={this.handleChange('address_line_1', 1)}
                          />

                          <TxtLbl
                            tagText={"Address Line 2"}
                            placeholder={"Address Line 2"}
                            value={this.state.formData.address_line_2.value}
                            onChange={this.handleChange('address_line_2', 1)}
                          />
                        </Form.Group>

                        <Form.Group widths='equal'>
                          <DrpDwn
                            // required
                            tagText={"Province/State"}
                            placeholder={"Province/State"}
                            value={this.state.formData.province_state.value}
                            options={this.props.provinces_list}
                            onChange={this.dropDownChange('province_state')}
                          />
                          <DrpDwn
                            // required
                            tagText={"District"}
                            placeholder={"Select district"}
                            value={this.state.formData.district.value}
                            options={this.props.districs_list}
                            onChange={this.dropDownChange('district')}
                          />

                        </Form.Group>

                        <Form.Group widths='equal'>
                          <TxtLbl
                            // required
                            tagText={"City/Town"}
                            placeholder={"City/Town"}
                            value={this.state.formData.city_town.value}
                            onChange={this.handleChange('city_town', 1)}
                          />
                          <TxtLbl
                            tagText={"Zip Code"}
                            placeholder={"Zip code"}
                            value={this.state.formData.zip.value}
                            onChange={this.handleChange('zip', 1)}
                          />
                        </Form.Group>

                        <Form.Group>
                          <strong style={{marginLeft: '8px', marginRight: '18px'}}>VIP</strong>
                          <br/>
                          <Checkbox toggle checked={this.state.isVIP} onChange={this.isVIPSelector}/>
                        </Form.Group>
                        {this.state.isVIP ?
                          <Form.Group>
                            <Label style={{marginLeft: '8px'}}>VIP Points</Label> <br/>
                            <TxtLbl
                              type='number'
                              placeholder={"VIP points"}
                              value={this.state.rating}
                              onChange={(value) => {
                                this.rateStarsVIP(value)
                              }}
                            />
                          </Form.Group> : null}

                      </Form>

                    </CardBody>
                  </Collapse>
                </Card>
              </Col>
              {this.props.userType === 'CORPORATE' ?
                <Col xs="12" lg={"6"} md={"6"} className={"padd_grap"}>
                  <Card className={this.state.completeEmg ? "border-danger" : null}>
                    <CardHeader>
                      EMERGENCY CONTACT DETAILS
                    </CardHeader>
                    <CardBody>
                      {/*EMERGENCY CONTACT DETAILS*/}

                      <Form>
                        <Form.Group widths='equal'>
                          <TxtLbl
                            // required
                            tagText={"Full Name"}
                            placeholder={"Full Name"}
                            value={this.state.formData.emgFullName.value}
                            onChange={this.handleChange('emgFullName', 1)}
                          />
                        </Form.Group>
                        <Form.Group widths='equal'>
                          <TxtLbl
                            // required
                            tagText={"Mobile Number"}
                            placeholder={"Mobile Number"}
                            value={this.state.formData.emgMobileNo.value}
                            onChange={this.handleChange('emgMobileNo', 1)}
                          />

                        </Form.Group>
                      </Form>
                    </CardBody>
                  </Card>
                  <Card className={this.state.completeCompany ? "border-danger" : null}>
                    <CardHeader>
                      COMPANY DETAILS
                    </CardHeader>
                    <CardBody>
                      {/*COMPANY DETAILS*/}

                      <Form>
                        <Form.Group widths='equal'>
                          <TxtLbl
                            required
                            tagText={"Emp ID"}
                            placeholder={"Emp ID"}
                            value={this.state.formData.empId.value}
                            onChange={this.handleChange('empId', 1)}
                          />
                        </Form.Group>

                        <Form.Group widths='equal'>
                          <DrpDwn
                            required
                            tagText={"Department"}
                            placeholder={"Department"}
                            options={rows}
                            value={this.state.formData.department.value}
                            onChange={this.dropDownChange('department')}
                          />

                        </Form.Group>
                        <Form.Group widths='equal'>
                          <TxtLbl
                            required
                            tagText={"Designation"}
                            placeholder={"Designation"}
                            value={this.state.formData.designation.value}
                            onChange={this.handleChange('designation', 1)}
                          />
                        </Form.Group>
                        <Form.Group widths='equal'>
                          <TxtLbl

                            tagText={"Budget Reference"}
                            placeholder={"Budget Reference"}
                            value={this.state.formData.budgetRef.value}
                            onChange={this.handleChange('budgetRef', 1)}
                          />
                        </Form.Group>
                        <Form.Group widths='equal'>
                          <TxtLbl

                            tagText={"Other Reference"}
                            placeholder={"Other Reference"}
                            value={this.state.formData.otherRef.value}
                            onChange={this.handleChange('otherRef', 1)}
                          />
                        </Form.Group>
                        <Form.Group widths='equal'>
                          <TxtLbl
                            tagText={"Extension"}
                            placeholder={"Extension"}
                            value={this.state.formData.extension.value}
                            onChange={this.handleChange('extension', 1)}
                          />
                        </Form.Group>
                      </Form>
                    </CardBody>
                  </Card>
                </Col> : null}
              -
              <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                <Button className="px-5" onClick={this.isValidate}>Update User</Button>
              </Col>
            </Row>
          </MDBModalBody>
        </MDBModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  provinces_list: state.addCorporateReducer.provinces,
  districs_list: state.addCorporateReducer.districs,
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
